import {createSlice, PayloadAction } from '@reduxjs/toolkit';

export const loggedValidationSlice = createSlice({
    name: 'loggedValidation',
    initialState: {
        loggedIn: false
    } as {loggedIn: boolean},
    reducers: {
        setLogged: (state, action: PayloadAction<boolean>) => {
            state.loggedIn = action.payload
        }
    }
});

export const {setLogged} = loggedValidationSlice.actions;
export default loggedValidationSlice.reducer;